export default __webpack_public_path__ + "3f7475f91e6bf5f6d3e8fd4d02599005.png";